module.exports = __webpack_public_path__ + "img/part2-uIcon3.8fc96f59.png";